import script from "./Regulation.vue?vue&type=script&setup=true&lang=js"
export * from "./Regulation.vue?vue&type=script&setup=true&lang=js"

import "./Regulation.vue?vue&type=style&index=0&id=70bc2e1f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70bc2e1f"]])

export default __exports__